import MidiToAudioChain from '../core/MidiToAudioChain';
import Instrument from './Instrument';
class DrumRack extends Instrument {
    constructor() {
        super(...arguments);
        this.pads = [];
    }
    pad(note) {
        if (!(this.pads[note] instanceof MidiToAudioChain)) {
            const chain = new MidiToAudioChain();
            chain.output().connect(this.output());
            this.pads[note] = chain;
        }
        return this.pads[note];
    }
    triggerAttack(note, time, velocity) {
        const chain = this.pads[note];
        if (chain) {
            chain.input().triggerAttack(60, time, velocity);
        }
        return this;
    }
    triggerRelease(time, note) {
        const chain = this.pads[note];
        if (chain) {
            chain.input().triggerRelease(time, 60);
        }
        return this;
    }
}
export default DrumRack;
//# sourceMappingURL=DrumRack.js.map